import makeStyles from '@material-ui/core/styles/makeStyles';
import { enLessonType } from 'interface/lesson';
import Audio from 'assets/img/audio.png';
import AudioWhite from 'assets/img/audio-white.png';

import Evaluation from 'assets/img/prova.png';
import { CourseTheme } from 'assets/themes/Course';
import { useAppSelector } from 'hooks/redux';
import { ICourse } from 'interface/course';

interface IProps {
  type: number;
}

const useStyles = makeStyles<CourseTheme>((theme) => ({
  coverContainer: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: 30,
  },
  coverImage: {
    width: '100%',
    maxWidth: 450,
  },
  title: {
    marginTop: 42,
    fontSize: 20,
    color: theme.variables.courseTheme.text,
    fontWeight: 700,
    textAlign: 'center',
  },
  description: {
    fontSize: 16,
    color: theme.variables.courseTheme.text,
    marginTop: 16,
    textAlign: 'center',
  },
  audioBlack: {
    content: `url(${Audio})`,
  },
  audioWhite: {
    content: `url(${AudioWhite})`,
  },
  evaluationBlack: {
    content: `url(${Evaluation})`,
  },
}));

const CoverImage = ({ type }: IProps) => {
  const classes = useStyles();

  const course = useAppSelector((state) => state.course as ICourse);

  const choiceContentType = {
    [enLessonType.AUDIO]: {
      image: ['audioBlack', 'audioWhite'],
      title: 'Conteúdo em áudio',
      description: 'Clique no player abaixo para iniciar a aula.',
    },
    [enLessonType.FABRICA_PROVAS]: {
      image: ['evaluationBlack'],
      title: 'Prova de avaliação',
      description: 'Clique no botão para acessar sua prova online.',
    },
  };

  const listContent = new Map(Object.entries(choiceContentType));

  const getImageByTheme = () => {
    const theme = course?.customizations?.theme;

    const img = choiceContentType[type].image[theme]
      ? choiceContentType[type].image[theme]
      : choiceContentType[type].image[0];

    return img;
  };

  return (
    listContent.has(`${type}`) && (
      <section className={classes.coverContainer}>
        <div className={classes.coverImage}>
          <img className={classes[getImageByTheme()]} alt='imagem do conteúdo' />
        </div>
        <section>
          <div className={classes.title}>{choiceContentType[type].title}</div>
          <div className={classes.description}>{choiceContentType[type].description}</div>
        </section>
      </section>
    )
  );
};

export default CoverImage;
